import { signOut } from 'firebase/auth';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { auth } from './firebase';
import './Navbar.css';

export default function NavbarLink() {

    const navigate = useNavigate();

    const closeNavbar = () => {
        const navbarToggle = document.querySelector('.navbar-toggler') as HTMLElement | null;
        if (navbarToggle && !navbarToggle.classList.contains('collapsed')) {
            navbarToggle.click();
        }
    };

    const goMain = () => {
        navigate('/main');
    };
    const goAlarmRecord = () => {
        navigate('/alarm');
    };
    const goFuelCal = () => {
        navigate('/fuel');
    };
    const goThermalCal = () => {
        navigate('/thermal');
    };
    const goContact = () => {
        navigate('/contact');
    };

    const logout = async () => {
        try {
            await signOut(auth);
            navigate('/');
        } catch (error) {
            console.error('Error signing out: ', error);
        }
    };

    return (
        <Navbar expand="lg" variant="dark" className="navbar-custom" onClick={closeNavbar}>
            <Container>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link onClick={goMain} className="nav-item-custom">
                            匯報Alarm
                        </Nav.Link>

                        <Nav.Link onClick={goAlarmRecord} className="nav-item-custom">
                            過往警報參考
                        </Nav.Link>

                        <Nav.Link onClick={goFuelCal} className="nav-item-custom">
                            發電機油秏估算
                        </Nav.Link>

                        <Nav.Link onClick={goThermalCal} className="nav-item-custom">
                            冷凍缸冷秏估算
                        </Nav.Link>

                        <Nav.Link onClick={goContact} className="nav-item-custom">
                            意見回報
                        </Nav.Link>

                        <Nav.Link onClick={logout} className="nav-item-custom">
                            登出
                        </Nav.Link>
                        
                    </Nav>
                </Navbar.Collapse>

            </Container>
        </Navbar>
    );
}